import { render, staticRenderFns } from "./form2.vue?vue&type=template&id=d194e7d6&scoped=true&"
import script from "./form2.vue?vue&type=script&lang=js&"
export * from "./form2.vue?vue&type=script&lang=js&"
import style0 from "./form2.vue?vue&type=style&index=0&id=d194e7d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d194e7d6",
  null
  
)

export default component.exports